import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  selector: 'aux-forecast-accrual-page',
  template: `
    <div class="mt-7">
      <router-outlet />
    </div>
  `,
})
export class ForecastAccrualsPageComponent {}
